import React from 'react'
import { FeatureListItem, SuccessIcon, PaddingWrapper, FeatureText } from './styles'

interface FeatureItemProps {
  featureText: string
  testId: string
}

export const FeatureItem: React.FC<FeatureItemProps> = ({ featureText, testId }) => (
  <FeatureListItem data-test={testId}>
    <SuccessIcon size="medium" />
    <PaddingWrapper>
      <FeatureText>{featureText}</FeatureText>
    </PaddingWrapper>
  </FeatureListItem>
)
